import { PDFQRText } from '../PDFQRText';

export const Video = ({ item }) => {
  return <PDFQRText description={item?.videoUrl} url={item?.videoUrl} />;
};
